import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'יתרונות', href: '/landing#features' },
  { label: 'מחירים',  href: '/landing#pricing'  },
  { label: 'אודות',   href: '/landing#about'    },
];

const PublicHeader: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-md border-b border-blue-100'
          : 'bg-white/95 backdrop-blur-sm border-b border-blue-50'
      }`}
    >
      {/* Top accent line — brand blue gradient */}
      <div className="h-1 w-full bg-gradient-to-l from-[#1565C0] via-[#29B6F6] to-[#1565C0]" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-90 transition-opacity">
            <img src="/amutech-logo.png" alt="Amutech" className="h-28 w-auto object-contain" />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-2" dir="rtl">
            {NAV_LINKS.map(link => (
              <a
                key={link.href}
                href={link.href}
                className="relative px-5 py-2.5 text-base font-semibold text-gray-600 hover:text-[#1565C0] transition-colors duration-200 group"
              >
                {link.label}
                <span className="absolute bottom-0 right-5 left-5 h-0.5 bg-[#1565C0] scale-x-0 group-hover:scale-x-100 transition-transform duration-200 origin-right rounded-full" />
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center gap-4" dir="rtl">
            <Link
              to="/login"
              className="text-base font-semibold text-gray-600 hover:text-[#1565C0] transition-colors duration-200"
            >
              כניסה
            </Link>

            {/* Divider */}
            <div className="w-px h-6 bg-gray-200" />

            <Link
              to="/register"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-base font-bold text-white
                         bg-gradient-to-l from-[#1565C0] to-[#1976D2]
                         hover:from-[#0D47A1] hover:to-[#1565C0]
                         shadow-md hover:shadow-lg transition-all duration-200 hover:scale-[1.03]"
            >
              התחל בחינם
              <svg width="16" height="16" viewBox="0 0 14 14" fill="none" className="rtl:rotate-180">
                <path d="M8.5 2.5L13 7L8.5 11.5M1 7H12.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>

        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
